import React from 'react';
import Color from 'color';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number | string;
  startGradient?: string;
  endGradient?: string;
  className?: string;
}

export const BackgroundDecoration: React.FC<Props> = ({
  width = 100,
  startGradient = colors.primary,
  endGradient = Color(colors.primary).lighten(0.5).hex(),
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1920 601"
    width={width}
    height={typeof width === 'number' ? width * (601 / 1920) : 'auto'}
    className={className}
  >
    <defs>
      <linearGradient
        id="a"
        x1={611.5}
        x2={775.926}
        y1={801}
        y2={219.344}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={353.849}
        x2={503.792}
        y1={154.248}
        y2={681.855}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={startGradient} />
        <stop
          offset={1}
          stopColor={endGradient}
        />
      </linearGradient>
      <linearGradient
        id="e"
        x1={2196.43}
        x2={909.476}
        y1={432.036}
        y2={123.489}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <linearGradient
        id="g"
        x1={2261.5}
        x2={1645.04}
        y1={186.5}
        y2={321.891}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={endGradient} />
        <stop
          offset={1}
          stopColor={startGradient}
        />
      </linearGradient>
      <filter
        id="d"
        width={2576.37}
        height={2833.86}
        x={73.183}
        y={-811.686}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={31.35} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_203_5179"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_203_5179"
          result="shape"
        />
      </filter>
      <filter
        id="f"
        width={2576.37}
        height={2833.86}
        x={1465.45}
        y={-913.526}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={31.35} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_203_5179"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_203_5179"
          result="shape"
        />
      </filter>
    </defs>
    <path
      fill="url(#a)"
      d="M0 0h1920v601H0z"
    />
    <mask
      id="c"
      width={1920}
      height={601}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="url(#b)"
        d="M0 0h1920v601H0z"
      />
    </mask>
    <g mask="url(#c)">
      <g filter="url(#d)">
        <path
          fill="url(#e)"
          d="M2570.94 226.13c20.74 22.761 21.27 57.414 1.22 80.792L1173.54 1938.18c-23.86 27.83-66.7 28.48-91.39 1.38L185.875 956.055c-16.369-17.962-20.515-43.927-10.553-66.093l28.201-62.749a60.999 60.999 0 0 0-2.557-55.06l-57.163-100.962c-14.029-24.777-9.05-55.963 11.995-75.141L1614.29-733.073c24.9-22.692 63.48-20.901 86.17 4l870.48 955.203Z"
        />
      </g>
      <g filter="url(#f)">
        <path
          fill="url(#g)"
          d="M1544.06 124.29c-20.74 22.762-21.27 57.414-1.22 80.792L2941.46 1836.34c23.86 27.83 66.7 28.48 91.39 1.38l896.28-983.505c16.36-17.962 20.51-43.926 10.55-66.093l-28.2-62.749a61.029 61.029 0 0 1 2.55-55.06l57.17-100.962c14.03-24.777 9.05-55.963-12-75.141L2500.71-834.912c-24.9-22.692-63.48-20.902-86.17 3.999L1544.06 124.29Z"
        />
      </g>
    </g>
  </svg>
);
